export default __webpack_public_path__ + "static/media/trash.ed30b6e5.svg";